import React, { useState, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@fortawesome/free-solid-svg-icons';
import api from '../config/api';
import './CampaignCalculator.css';

const CampaignCalculator = ({ cartItems, onCampaignCalculated, showInSummary = false }) => {
  const [campaignData, setCampaignData] = useState(null);
  const [isCalculatingCampaign, setIsCalculatingCampaign] = useState(false);

  // Kampanya hesaplama
  const calculateCampaign = useCallback(async () => {
    if (!cartItems || cartItems.length === 0) {
      setCampaignData(null);
      if (onCampaignCalculated) {
        onCampaignCalculated(null);
      }
      return;
    }

    setIsCalculatingCampaign(true);
    try {
      const response = await api.post('/parameters/campaign/calculate-buy-x-get-x', {
        cartItems: cartItems.map(item => ({
          id: item.id || item.product?.id,
          price: item.product?.price || item.price,
          quantity: item.quantity || 1
        }))
      });

      if (response.data.success) {
        const campaignResult = response.data.data;
        setCampaignData(campaignResult);
        // Parent component'e kampanya bilgisini gönder
        if (onCampaignCalculated) {
          onCampaignCalculated(campaignResult);
        }
      } else {
        // Kampanya aktif değilse null gönder
        setCampaignData(null);
        if (onCampaignCalculated) {
          onCampaignCalculated(null);
        }
      }
    } catch (error) {
      console.error('Kampanya hesaplanırken hata:', error);
      setCampaignData(null);
      // Hata durumunda da parent'a null gönder
      if (onCampaignCalculated) {
        onCampaignCalculated(null);
      }
    } finally {
      setIsCalculatingCampaign(false);
    }
  }, [cartItems, onCampaignCalculated]);

  // Cart değiştiğinde kampanya hesapla
  useEffect(() => {
    calculateCampaign();
  }, [calculateCampaign]);

  // Kampanya aktif değilse hiçbir şey gösterme
  if (!campaignData || !campaignData.campaignActive) {
    return null;
  }

  // Özet görünümü (Checkout sayfası için)
  if (showInSummary) {
    return (
      <div className="campaign-summary">
        <div className="campaign-summary-badge">
          <FontAwesomeIcon icon={faTag} />
          <span>Kampanya</span>
        </div>
        <div className="campaign-summary-content">
          <span className="campaign-summary-text">
            {campaignData.requiredItems} ürün alana {campaignData.campaignDetails?.get || 1} ürün bedava
          </span>
          <span className="campaign-summary-savings">
            -{campaignData.savings.toFixed(2)} TL
          </span>
        </div>
      </div>
    );
  }

  // Tam görünüm (Cart sayfası için)
  return (
    <div className="campaign-info">
      <div className="campaign-badge">
        <FontAwesomeIcon icon={faTag} />
        <span>Kampanya</span>
      </div>
      
      <div className="campaign-content">
        <p className="campaign-text">{campaignData.message}</p>
        
        {campaignData.freeItems > 0 && (
          <div className="campaign-highlight">
            <span className="savings">-{campaignData.savings.toFixed(2)} TL</span>
            <span className="free-count">{campaignData.freeItems} ürün bedava</span>
          </div>
        )}
      </div>
      
      {isCalculatingCampaign && (
        <div className="campaign-loading">
          <span className="spinner-border spinner-border-sm" />
        </div>
      )}
    </div>
  );
};

export default CampaignCalculator;
